<template>
  <main class="profile-page">
    <header class="profile-shell-header">
      <div>
        <p>Account settings</p>
        <h1>My Profile</h1>
      </div>
      <div class="profile-lab-pill">
        <span>{{ labId || "Current lab" }}</span>
        <strong>{{ userRole }}</strong>
      </div>
    </header>

    <form ref="theform" class="profile-workspace" @submit.prevent="">
      <aside class="profile-identity-card">
        <input
          id="file-upload"
          ref="photoinput"
          disabled
          type="file"
          accept="image/*"
          name="photo"
          @change="changePhoto($event)"
        />
        <label class="profile-photo-button" for="file-upload">
          <img
            ref="photoelement"
            :class="{ photoenabled: editMode }"
            :src="
              appStore.state.activeUser.photo
                ? appStore.state.hostname + '/img/users/' + appStore.state.activeUser.photo
                : 'https://d1muf25xaso8hp.cloudfront.net/https%3A%2F%2Fs3.amazonaws.com%2Fappforest_uf%2Ff1583584638543x692525241529171000%2Fperson-placeholder-male-5.jpg?w=192&h=202&auto=compress&dpr=1.25&fit=max'
            "
            alt=""
          />
        </label>
        <div class="identity-copy">
          <p>{{ userRole }}</p>
          <h2>{{ firstName }} {{ lastName }}</h2>
          <small>{{ emailAddress }}</small>
        </div>
        <div class="profile-actions">
          <label class="edit-toggle" for="editinfo">
            <input id="editinfo" type="checkbox" @change="onEdit($event)" />
            <span>Edit info</span>
          </label>
          <button
            type="submit"
            :disabled="!editMode"
            class="save-command"
            :class="[editMode ? 'buttonactive' : 'buttondisabled']"
            @click="saveProfile"
          >
            Save
          </button>
        </div>
      </aside>

      <section class="profile-fields-card">
        <header>
          <p>Personal information</p>
          <h2>Contact and lab details</h2>
        </header>
        <div class="profile-fields-grid">
          <label>
            <span>First name</span>
            <input ref="firstnameinput" disabled :value="firstName" type="text" :class="{ inputenabled: editMode }" />
          </label>
          <label>
            <span>Last name</span>
            <input ref="lastnameinput" disabled :value="lastName" type="text" :class="{ inputenabled: editMode }" />
          </label>
          <label class="wide-field">
            <span>Email</span>
            <input disabled readonly :value="emailAddress" type="email" :class="{ inputenabled: editMode }" />
          </label>
          <label>
            <span>Phone</span>
            <input ref="phoneinput" disabled :value="phoneNumber" type="tel" :class="{ inputenabled: editMode }" />
          </label>
          <label>
            <span>Group</span>
            <input disabled readonly :value="labId" type="text" :class="{ inputenabled: editMode }" />
          </label>
          <label>
            <span>Title</span>
            <input disabled readonly :value="userRole" class="capitalize" type="text" :class="{ inputenabled: editMode }" />
          </label>
          <label>
            <span>Country</span>
            <input ref="countryinput" disabled :value="country" type="text" :class="{ inputenabled: editMode }" />
          </label>
          <label class="wide-field">
            <span>Address 1</span>
            <input ref="address1input" disabled :value="addressOne" placeholder="Address" type="text" :class="{ inputenabled: editMode }" />
          </label>
          <label class="wide-field">
            <span>Address 2</span>
            <input ref="address2input" disabled :value="addressTwo" placeholder="City - State - Zip Code" type="text" :class="{ inputenabled: editMode }" />
          </label>
        </div>
      </section>
    </form>
  </main>
</template>
<script>
import { ref } from "vue";
import store from "../../../store/index.js";
export default {
  setup() {
    const theform = ref(null);
    const editMode = ref(false);

    const address1input = ref(null);
    const address2input = ref(null);
    const phoneinput = ref(null);
    const countryinput = ref(null);
    const firstnameinput = ref(null);
    const lastnameinput = ref(null);
    const photoinput = ref(null);
    const photoelement = ref(null);

    function changePhoto(event) {
      photoelement.value.src = URL.createObjectURL(event.target.files[0]);
      photoelement.value.onload = function() {
        URL.revokeObjectURL(photoelement.value.src); // free memory
      };
    }

    function saveProfile() {
      console.log("clickedd");
      const url = store.state.hostname + "/api/v1/users/updateMe";
      const form = new FormData();
      form.append(
        "name",
        firstnameinput.value.value + " " + lastnameinput.value.value
      );
      form.append("address1", address1input.value.value);
      form.append("address2", address2input.value.value);
      form.append("phone", phoneinput.value.value);
      form.append("country", countryinput.value.value);
      if (photoinput.value.files[0])
        form.append("photo", photoinput.value.files[0]);
      // const bodytopass = {
      //   name: firstnameinput.value.value + " " + lastnameinput.value.value,
      //   address1: address1input.value.value,
      //   address2: address2input.value.value,
      //   phone: phoneinput.value.value,
      //   country: countryinput.value.value,
      //   photo: photoinput.value.files[0],
      // };
      console.log(photoinput.value.files[0]);
      const request = new Request(url, {
        credentials: "include",
        method: "PATCH",
        body: form,
      });
      fetch(request)
        .then((resp) => resp.json())
        .then((data) => {
          if (data.status == "fail") throw new Error(data.message);
          else {
            // console.log(data.data.data);
            //context.commit("updateUserData", { value: data.data.data });
            //arrayOfDewars.value = data.data.data;
            store.dispatch("login");
            onEdit();
          }
        })
        .catch((err) => console.log(err));
    }

    function onEdit(ev) {
      theform.value.querySelectorAll("input");
      if (ev?.target?.checked) {
        editMode.value = true;

        for (
          let i = 0;
          i < theform.value.querySelectorAll("input").length;
          i++
        ) {
          theform.value.querySelectorAll("input")[i].disabled = false;
        }
      } else {
        editMode.value = false;
        for (
          let i = 0;
          i < theform.value.querySelectorAll("input").length;
          i++
        ) {
          theform.value.querySelectorAll("input")[i].disabled = true;
        }
        theform.value.querySelector("#editinfo").disabled = false;
        theform.value.querySelector("#editinfo").checked = false;
      }
    }

    return {
      theform,
      onEdit,
      editMode,
      saveProfile,
      firstnameinput,
      lastnameinput,
      address1input,
      address2input,
      countryinput,
      phoneinput,
      photoinput,
      photoelement,
      changePhoto,
    };
  },
  computed: {
    firstName() {
      const nameArray = this.appStore.state.activeUser?.name?.split(" ");
      console.log(nameArray);

      return nameArray?.[0];
    },
    lastName() {
      const nameArray = this.appStore.state.activeUser?.name?.split(" ");
      return nameArray?.[1];
    },
    emailAddress() {
      return this.appStore.state.activeUser?.email;
    },
    phoneNumber() {
      return this.appStore.state.activeUser?.phone;
    },
    labId() {
      return this.appStore.state.activeUser?.labId?.name;
    },
    country() {
      return this.appStore.state.activeUser?.country;
    },
    addressOne() {
      return this.appStore.state.activeUser?.address1;
    },
    addressTwo() {
      return this.appStore.state.activeUser?.address2;
    },
    userRole() {
      if (this.appStore.state.activeUser?.role == "user") return "Lab Member";

      return this.appStore.state.activeUser?.role.split("-").join(" ");
    },
  },
};
</script>
<style scoped>
.profile-page {
  display: grid;
  align-content: start;
  min-height: calc(100vh - 24px);
  background: #fff;
  color: #172033;
  font-family: Montserrat, Inter, system-ui, sans-serif;
}

.profile-shell-header {
  display: flex;
  justify-content: space-between;
  gap: 14px;
  align-items: center;
  padding: 14px 18px;
  border-bottom: 1px solid #dbe3ef;
  background: #fff;
}

.profile-shell-header p,
.profile-fields-card header p,
.identity-copy p,
.profile-fields-grid span {
  margin: 0;
  color: #64748b;
  font-size: 11px;
  font-weight: 900;
  text-transform: uppercase;
}

.profile-shell-header h1,
.profile-fields-card header h2,
.identity-copy h2 {
  margin: 2px 0 0;
  color: #172033;
  line-height: 1.15;
}

.profile-shell-header h1 {
  font-size: 20px;
}

.profile-lab-pill {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  min-height: 34px;
  padding: 0 12px;
  border: 1px solid #dbe3ef;
  border-radius: 999px;
  background: #f8fafc;
  color: #526173;
  font-size: 12px;
  font-weight: 800;
}

.profile-lab-pill strong {
  color: #172033;
  text-transform: capitalize;
}

.profile-workspace {
  display: grid;
  grid-template-columns: minmax(260px, 320px) minmax(0, 1fr);
  gap: 12px;
  padding: 12px;
}

.profile-identity-card,
.profile-fields-card {
  min-width: 0;
  border: 1px solid #dbe3ef;
  border-radius: 8px;
  background: #fff;
}

.profile-identity-card {
  display: grid;
  align-content: start;
  justify-items: center;
  gap: 14px;
  padding: 18px;
  text-align: center;
}

#file-upload {
  display: none;
}

.profile-photo-button {
  display: block;
  cursor: default;
}

.profile-photo-button img {
  width: 132px;
  height: 132px;
  border: 1px solid #cbd5e1;
  border-radius: 999px;
  background: #e7eef7;
  object-fit: cover;
}

.photoenabled {
  border: 2px dashed #0f766e !important;
  cursor: pointer;
}

.identity-copy {
  min-width: 0;
}

.identity-copy h2 {
  font-size: 22px;
  text-transform: capitalize;
}

.identity-copy small {
  display: block;
  margin-top: 4px;
  color: #64748b;
  font-size: 12px;
  font-weight: 800;
}

.profile-actions {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 10px;
}

.edit-toggle {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  color: #334155;
  font-size: 13px;
  font-weight: 900;
  cursor: pointer;
}

.edit-toggle input {
  width: 16px;
  height: 16px;
  margin: 0;
}

.save-command {
  min-height: 34px;
  padding: 0 16px;
  border: 1px solid #0f766e;
  border-radius: 6px;
  background: #0f766e;
  color: #fff;
  font: inherit;
  font-size: 13px;
  font-weight: 900;
}

.buttondisabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.buttonactive {
  cursor: pointer;
}

.profile-fields-card header {
  padding: 14px;
  border-bottom: 1px solid #dbe3ef;
}

.profile-fields-card header h2 {
  font-size: 18px;
}

.profile-fields-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
  padding: 14px;
}

.profile-fields-grid label {
  display: grid;
  gap: 6px;
  min-width: 0;
}

.wide-field {
  grid-column: 1 / -1;
}

.profile-fields-grid input {
  width: 100%;
  height: 38px;
  margin: 0;
  padding: 0 10px;
  border: 1px solid #dbe3ef;
  border-radius: 7px;
  background: #f1f5f9;
  color: #172033;
  font: inherit;
  font-size: 13px;
}

.profile-fields-grid input:focus {
  outline: none;
  border-color: #6889b3;
  box-shadow: 0 0 0 3px rgb(51 92 139 / 0.12);
}

.inputenabled {
  border-color: #9db4d0 !important;
  background: #fff !important;
  color: #172033 !important;
}

@media (max-width: 900px) {
  .profile-workspace,
  .profile-fields-grid {
    grid-template-columns: 1fr;
  }

  .wide-field {
    grid-column: auto;
  }
}

@media (max-width: 720px) {
  .profile-shell-header {
    align-items: flex-start;
    flex-direction: column;
  }

  .profile-lab-pill {
    align-items: flex-start;
    flex-direction: column;
    height: auto;
    padding: 8px 12px;
    border-radius: 8px;
  }
}
</style>
